export const clientDriverPermission = {
  isDriver: true,
};
